import { render } from "./NumberWithUnit.vue?vue&type=template&id=085db6e6&lang=pug"
import script from "./NumberWithUnit.vue?vue&type=script&lang=ts"
export * from "./NumberWithUnit.vue?vue&type=script&lang=ts"

import "./NumberWithUnit.vue?vue&type=style&index=0&id=085db6e6&lang=scss"
script.render = render

export default script